var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM5 4H19C19.5523 4 20 4.44771 20 5V5.70802C19.6938 5.57422 19.3556 5.5 19 5.5H5C4.64445 5.5 4.30623 5.57422 4 5.70802V5C4 4.44771 4.44772 4 5 4ZM4 11C4 10.4477 4.44772 10 5 10H19C19.5523 10 20 10.4477 20 11V14.25C20.4142 14.25 20.75 14.5858 20.75 15C20.75 15.4142 20.4142 15.75 20 15.75H17.3744C16.9108 15.75 16.5067 16.0655 16.3943 16.5152C15.919 18.4163 14.2109 19.75 12.2513 19.75H11.7487C9.78913 19.75 8.081 18.4163 7.60573 16.5152C7.49329 16.0655 7.08921 15.75 6.62563 15.75H4C3.58579 15.75 3.25 15.4142 3.25 15C3.25 14.5858 3.58579 14.25 4 14.25V11ZM5 7H19C19.5523 7 20 7.44771 20 8V8.70802C19.6938 8.57422 19.3556 8.5 19 8.5H5C4.64445 8.5 4.30623 8.57422 4 8.70802V8C4 7.44771 4.44772 7 5 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxArchive);
export default __webpack_public_path__ + "static/media/inbox-archive.ea40fd52f350cde1d96651d78dd05b6d.svg";
export { ForwardRef as ReactComponent };